/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Link_Use_TitleInputs */



/**
* | output |
* | --- |
* | "Use the page title" |
*
* @param {Community_Link_Use_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_link_use_title = /** @type {((inputs?: Community_Link_Use_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Link_Use_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utiliser le titre de la page")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usar el título de la página")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Usar o título da página")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa il titolo della pagina")
	return /** @type {LocalizedString} */ ("Use the page title")
});